import { useBondsBondFieldApi } from '../api';

export const useBondsBondSQuoteArchiveDate = () => {
  const response = useBondsBondFieldApi('S_QUOTE.ARCHIVE_DATE');
  return response;
};
